import { render, staticRenderFns } from "./EditExaminationDetails.vue?vue&type=template&id=d895ae98&scoped=true"
import script from "./EditExaminationDetails.vue?vue&type=script&lang=js"
export * from "./EditExaminationDetails.vue?vue&type=script&lang=js"
import style0 from "./EditExaminationDetails.vue?vue&type=style&index=0&id=d895ae98&prod&scoped=true&lang=css"
import style1 from "./EditExaminationDetails.vue?vue&type=style&index=1&id=d895ae98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d895ae98",
  null
  
)

export default component.exports